import React, { useState } from "react";
import ProgressiveImage from "react-progressive-graceful-image";

import Loader from "../../../component/loader";

// render Image Component
function ImageComponent({ src, alt, color, key, style, ...rest }) {
  const [isLoading, setIsLoading] = useState(false);
  const borderRaduses =
    color?.elements?.shape === "Pill"
      ? "16px"
      : color?.elements?.shape === "Rounded"
      ? "16px"
      : "0px";

  const imageStyle = {
    objectFit: "cover",
    borderRadius: borderRaduses,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    aspectRatio: rest.isCarousel && rest.aspectRatio,
  };
  return (
    // load image progressively when loading show loader
    <ProgressiveImage src={src} delay={600} placeholder={rest.gif}>
      {(src, loading) => (
        <div>
          {loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader width={"40px"} />
            </div>
          )}
          {!loading && <img src={src} alt={alt} style={imageStyle} />}
        </div>
      )}
    </ProgressiveImage>
  );
}

// export component Image
export default ImageComponent;
